<i18n>
en:
  title: "Regist image"
  file:
    label: "Image file"
    error: "The image cannot be read"
  comment:
    label: "Comment"
  submit: "Regist"

ja:
  title: "画像登録"
  file:
    label: "画像ファイル"
    error: "画像が読み取れません"
  comment:
    label: "コメントを入力する"
  submit: "登録する"
</i18n>

<template lang="pug">
  div.my-6
    v-container
      //- タイトル
      v-row
        v-col(cols="12" align="center")
          h2|{{$t('title')}}
        v-col.pt-0.pb-4(cols="12" align="center")
          v-img(src="@/assets/images/title-underline.png" width="227px" height="24px")

      //- 読込中
      template(v-if="isLoading")
        v-row
          v-col.my-12.pa-12(cols="12")
            v-progress-linear(indeterminate)

      //- 入力フォーム
      template(v-else)
        v-form.px-md-8.px-lg-10.px-xl-12(onsubmit="return false" v-model="valid")
          v-row
            v-col(cols="12")
              v-file-input.required(accept="image/*" :label="$t('file.label')" :error="validImage.error" :error-messages="validImage.message" v-model="forms.file")

          v-row(justify="center")
            v-col(cols="12" sm="6" md="4" xl="2")
              v-btn.white--text(x-large block color="teal" @click="addImages" :disabled="!valid || !forms.file")
                v-icon|fa-angle-double-down

          v-row
            v-col(cols="12")
              v-slide-group(show-arrows v-model="activeImage")
                v-slide-item(v-for="(item, index) in forms.images" :key="index" v-slot:default="{ toggle }")
                  v-card.card.mx-1.my-2.pa-2
                    v-img(contain height="250" width="250" :src="`data:image/png;base64,${item.imgSrc}`")
                    v-btn.card-delete-icon.white--text(fab small color="red" @click="removeImages(index)")
                      v-icon|fa-trash-alt
                    v-card-text.px-0
                      v-text-field(hide-details :label="$t('comment.label')" maxlength="100" v-model="item.imgText")

          v-row(justify="center")
            v-col(cols="12" sm="6" md="4" xl="2")
              v-btn.white--text(x-large block color="primary" @click="regist" :loading="isSubmit" :disabled="forms.images.length === 0")|{{$t('submit')}}
</template>

<script>
export default {
  data () {
    return {
      // 入力フォーム
      forms: {
        file: null,
        fileData: null,
        images: []
      },
      // アクティブ対象の画像
      activeImage: null,
      // 入力バリデーション
      valid: false,
      // 送信中
      isSubmit: false,
      // 読込中
      isLoading: true,
      // エラーメッセージ
      errMsg: null
    }
  },
  created () {
    this.loadImage()
  },
  computed: {
    validImage () {
      if (!this.forms.file || (this.forms.fileData && this.forms.fileData.length > 5)) {
        return {
          error: false,
          message: null
        }
      } else {
        return {
          error: true,
          message: this.$t('file.error')
        }
      }
    }
  },
  watch: {
    'forms.file' (val) {
      this.readImageFile(val, this.forms)
    }
  },
  methods: {
    /**
     * 画像を読込
     */
    loadImage () {
      this.api.shopImage({})
        .then(response => {
          this.forms.images = response.data.shopImgList
        })
        .catch(response => {
          this.errMsg = this.$t(`error.${response.functionError.errorCode}`)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    /**
     * 画像ファイルを読込
     */
    readImageFile (image, item) {
      if (image) {
        const reader = new FileReader()
        reader.addEventListener('load', () => {
          item.fileData = this.utils.image.removeMime(reader.result)
        })
        reader.readAsDataURL(image)
      } else {
        this.forms.fileData = null
      }
    },
    /**
     * 画像を追加
     */
    addImages () {
      this.forms.images.push({
        imgSrc: this.forms.fileData,
        imgText: ''
      })
      this.activeImage = this.forms.images.length - 1
      this.forms.file = null
    },
    /**
     * 画像を削除
     */
    removeImages (index) {
      this.forms.images.splice(index, 1)
    },
    /**
     * 登録
     */
    regist () {
      if (this.isSubmit) {
        return
      }

      this.isSubmit = true
      this.errMsg = null

      this.api.shopImageRegist({
        imageList: Array.from(this.forms.images, item => item.imgSrc),
        imageCommentList: Array.from(this.forms.images, item => item.imgText)
      })
        .then(response => {
          this.$router.push({name: 'ShopComplete'})
        })
        .catch(response => {
          this.errMsg = this.$t(`error.${response.functionError.errorCode}`)
        })
        .finally(() => {
          this.isSubmit = false
        })
    }
  }
}
</script>

<style lang="sass" scoped>
.card
  position: relative

  &-delete-icon
    position: absolute
    top: 0
    right: 0
</style>
